import { render, staticRenderFns } from "./change-fee-table.vue?vue&type=template&id=d5792c58&scoped=true&"
import script from "./change-fee-table.vue?vue&type=script&lang=js&"
export * from "./change-fee-table.vue?vue&type=script&lang=js&"
import style0 from "./change-fee-table.vue?vue&type=style&index=0&id=d5792c58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5792c58",
  null
  
)

export default component.exports